export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["स्टोर चुनें"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["शीर्षकहीन"])}
}